import { render } from "./VLiquor.vue?vue&type=template&id=7c7d8433"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/VLiquor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c7d8433"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c7d8433', __exports__)) {
    api.reload('7c7d8433', __exports__)
  }
  
  module.hot.accept("./VLiquor.vue?vue&type=template&id=7c7d8433", () => {
    api.rerender('7c7d8433', render)
  })

}


export default __exports__